import React, { useState } from 'react';
import CabinCrewSidebar from '../components/CabinCrewSidebar';

export default function CabinCrewLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <CabinCrewSidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
      
      {/* Main Content */}
      <main 
        className={`
          transition-all duration-300 min-h-screen
          ${sidebarOpen ? 'lg:ml-64' : 'lg:ml-20'}
          pt-16 lg:pt-0
        `}
      >
        {children}
      </main>
    </div>
  );
}
